import { CanvasF } from '../../../../../Canvas/F/Function/module/CanvasF.js';
import { MuiF } from '../../../../../Mui/F/Function/module/MuiF.js';
import { SimpleModalMuiF } from '../../../../../SimpleModal/F/Mui/module/SimpleModalMuiF.js';
import { go, html, sel, strMap } from 'fxjs/es';
import { $delegate } from 'fxdom/es';
import { NewMakerUtilF } from '../../../../Util/F/Function/module/NewMakerUtilF.js';
import { UtilF } from '../../../../../Util/F/Function/module/UtilF.js';
import { makeCanvasByContrastEffect, makeCanvasByUrl } from '../../../../../Canvas/S/util.js';
//
// const original = new Map();
export const invertedImage = {
  invertImageOfCvImage: async (cv_obj, checked) => {
    cv_obj._data.is_inverted_image = checked;
    cv_obj._element = cv_obj._data.is_inverted_image
      ? await go(invertedImage.toOriginalCanvas(cv_obj), (canvas) => CanvasF.invertImage(canvas))
      : await invertedImage.toOriginalCanvas(cv_obj);
    cv_obj.canvas.renderAll();
  },
  toOriginalCanvas: async (cv_obj) => {
    return makeCanvasByContrastEffect(await makeCanvasByUrl(cv_obj.src), cv_obj._data.shade_default_hex);
  },
  rollBackToOriginal: async (cv_obj) => {
    delete cv_obj._data.is_inverted_image;
    cv_obj._element = await invertedImage.toOriginalCanvas(cv_obj);
    $.alert(T('maker_error_alert::문제가 발생했습니다. 다시 시도해 주세요.'));
    cv_obj.canvas.renderAll();
  },
  openPopUp: async () => {
    const pc = {
      url: '//s3.marpple.co/files/u_193535/2025/2/original/80712fbe8b06b5a7f8b6e21864b8884b45688cf91.jpg',
      url_en: '//s3.marpple.co/files/u_193535/2025/2/original/3ebbfb242831d68858607f28b3683d57fc2ad21e7.jpg',
      url_jp: '//s3.marpple.co/files/u_193535/2025/2/original/f656bdd58cdf06644b89b81ca2b5a043c5b8c11d4.jpg',
    };
    const mobiles = [
      {
        url: '//s3.marpple.co/files/u_193535/2025/2/original/10a271f6075c161190666f191f5c2766b4be690f3.jpg',
        url_en:
          '//s3.marpple.co/files/u_193535/2025/2/original/647619df27fdb6fddb1f251cf14f5997f827746b1.jpg',
        url_jp:
          '//s3.marpple.co/files/u_193535/2025/2/original/1da155f6f846e950e7fe5acc6647c5cbe4814b795.jpg',
      },
      {
        url: '//s3.marpple.co/files/u_193535/2025/2/original/6f83b1a6682c1c38c78ca8b0091ba405a208bfe42.jpg',
        url_en:
          '//s3.marpple.co/files/u_193535/2025/2/original/4baeb1fd40cf0ef6fd5687cd853c65b64628f3616.jpg',
        url_jp:
          '//s3.marpple.co/files/u_193535/2025/2/original/bb07925b75b9c545720c64a284075d77d59b0a024.jpg',
      },
    ];
    await MuiF.openFrame(SimpleModalMuiF.frame, async (frame, page, [tab]) => {
      tab.appended = (tab_el) =>
        go(
          tab_el,
          $delegate('click', '.done', () => {
            MuiF.closeFrame();
          }),
        );
      tab.showed = (tab_el) => {
        new Swiper(tab_el.querySelector('.swiper-container'), {});
      };
      tab.makeData = () => {
        return {
          header_height: 0,
          body: UtilF.isLegacyMobile()
            ? html`
                <div class="swiper-container" data-length="${sel('length', mobiles)}">
                  <div class="swiper-wrapper">
                    ${strMap(
                      (mobile) => `
                        <div class='swiper-slide article-detail__photo'>
                          <img src='${mobile['url' + G._en]}' alt='' style="width:100%"/>
                        </div>
                      `,
                      mobiles,
                    )}
                  </div>
                </div>
              `
            : html` <img src="${pc['url' + G._en]}" alt="" style="width:100%" /> `,
          footer: html`
            <button type="button" class="done" style="${NewMakerUtilF.getCssStyle()};">
              ${T('maker::check')}
            </button>
          `,
        };
      };
    });
  },
};
